import Vue from 'vue';
import Vuex from 'vuex';
import demoreset from './demoreset';
Vue.use(Vuex);

export default new Vuex.Store({
  modules:{
    demoreset
  },
});

